<template>
  <ca-modal
    ref="modal"
    title="Selecione um turno">
    <template slot="body">
      <ca-async-content-wrapper
        :key="wrapperKey"
        :on-fetch="getWorkShifts"
        :on-fetch-success="setWorkShifts">
        <ca-table>
          <ca-tr slot="header">
            <ca-th size="3">Código</ca-th>
            <ca-th size="2">Hr entrada</ca-th>
            <ca-th size="2">Hr saída</ca-th>
            <ca-th size="3">Duração</ca-th>
            <ca-th size="2">Intervalo</ca-th>
            <ca-th size="3">Duração Intervalo</ca-th>
            <ca-th size="3"></ca-th>
            <ca-th size="5"></ca-th>
          </ca-tr>

          <ca-tr v-for="(shift, index) in workShifts.content" :key="index">
            <ca-td>{{ shift.code }}</ca-td>
            <ca-td>{{ shift.checkInTime }}</ca-td>
            <ca-td>{{ shift.checkOutTime }}</ca-td>
            <ca-td>{{ `${shift.workingHours} horas` }}</ca-td>
            <ca-td>{{ shift.breakType.description }}</ca-td>
            <ca-td>{{ getIntervalDuration(shift) }}</ca-td>
            <ca-td>
              <ca-button
                size="small"
                @click="() => onAddShift(shift)">
                Adicionar
              </ca-button>
            </ca-td>
            <ca-td>
              <ca-button
                size="small"
                @click="() => onAddWeekShift(shift)">
                Adicionar Seg. à Sex.
              </ca-button>
            </ca-td>
          </ca-tr>
        </ca-table>

        <ca-row vertical-offset="2">
          <ca-col class="ca-u-text-center">
            <ca-pagination
              v-if="workShifts.totalPages > 1"
              v-model="currentPage"
              :total-pages="workShifts.totalPages"
              class="ca-u-flex ca-u-align-items--center ca-u-justify-content--center">
            </ca-pagination>
          </ca-col>
        </ca-row>
      </ca-async-content-wrapper>
    </template>

    <ca-row slot="footer">
      <ca-col size="3">
        <ca-button full-width @click="close">
          Fechar
        </ca-button>
      </ca-col>
    </ca-row>
  </ca-modal>
</template>

<script>
import { getWorkShifts } from 'accountant/employer/work-shifts/workShiftService';
import { getIntervalDuration, addShift, addWeekShift } from '../../../workersService';
import { addShiftToDraft, addWeekShiftToDraft } from '../workerShiftInfoService';

export default {
  name: 'CreateShiftModal',
  props: {
    selectedDay: String,
    isDraft: Boolean,
    workerId: String,
  },
  data() {
    return {
      wrapperKey: 0,
      currentPage: 0,
      workShifts: {},
    };
  },
  watch: {
    currentPage() {
      this.updateList();
    },
  },
  methods: {
    getIntervalDuration,
    getWorkShifts() {
      return getWorkShifts({ page: this.currentPage });
    },
    async setWorkShifts(workShifts) {
      this.workShifts = workShifts;
    },
    updateList() {
      this.wrapperKey++;
    },
    close() {
      this.$refs.modal.close();
    },
    async onAddShift(shift) {
      try {
        if (this.isDraft) {
          addShiftToDraft(shift, this.selectedDay);
        } else {
          await addShift(this.workerId, shift.id, this.selectedDay);
        }
        this.onSuccessAdded();
      } catch (err) {
        this.$toaster.error('Não foi possível adicionar o dia ao turno.');
      }
    },
    async onAddWeekShift(shift) {
      try {
        if (this.isDraft) {
          addWeekShiftToDraft(shift);
        } else {
          await addWeekShift(this.workerId, shift.id);
        }
        this.onSuccessAdded();
      } catch (err) {
        this.$toaster.error('Não foi possível adicionar os dias ao turno.');
      }
    },
    onSuccessAdded() {
      this.$emit('shift-added');
      this.close();
      this.$toaster.success('Turno adicionado com sucesso!');
    },
  },
};
</script>
